import {observer} from 'mobx-react';
import React, {useContext, useEffect, useState} from 'react';
import Helmet from 'react-helmet';
import {Button, Paper, Typography} from '../../../common/components/libs';
import {useStores} from '../../../hooks';
import DocumentsStoreContext from '../context';
import {
    Box, Collapse, FormControl, Input, InputLabel,
} from '@material-ui/core';
import {TariffCard} from '../components/TariffCard';
import {TariffPaymentForm} from '../components/forms/TariffPaymentForm';
import {TariffTypes, TariffVariant} from '../models';
import moment from 'moment';
import {ExpandLess, ExpandMore} from '@material-ui/icons';
import {localize} from '../../../common/libs';
import {CompanyCard, CompanyCardTypes} from '../../../services/organizationBranches/models';
import { EditLegalData } from '../components/EditLegalData';

const dateColors = {
    active: {
        color: '#2d81e0',
        backgroundColor: 'rgba(96,149,236,0.12)'
    },
    overdue: {
        color: '#724800', // #faa600
        backgroundColor: 'rgba(255,206,116,0.3)'
    },
    expired: {
        color: '#ee412b',
        backgroundColor: 'rgba(221,71,59,0.12)'
    }
}

const TariffPage = () => {
    const {generalStore, constantsStore} = useStores();
    const documentsStore = useContext(DocumentsStoreContext);
    const {isOrganizationBranchLoaded, organizationBranch} = documentsStore;
    const [openForm, setOpenForm] = useState<boolean>(false)
    const [chosenTariff, setChosenTariff] = useState<TariffVariant>('Simple')
    const [expanded, setExpanded] = useState<boolean>(false)
    const [companyCard, setCompanyCard] = useState<CompanyCard | null>(null)

    const getFlags = () => {
        if (!isOrganizationBranchLoaded) return

        const tariffDetails = organizationBranch.activeTariffDetails
        const now = new Date()
        const menusActiveTillDate = tariffDetails.menusActiveTillDate
        const nextPaymentDate = tariffDetails.nextPaymentDate

        return {
            isActive: now <= nextPaymentDate,
            isExpired: now > menusActiveTillDate
        }
    }

    const getBadgeColors = () => {
        const flags = getFlags()

        if (flags.isActive) {
            return dateColors.active
        } else if (!flags.isExpired) {
            return dateColors.overdue
        } else {
            return dateColors.expired
        }
    }

    const getBadgeText = () => {
        const flags = getFlags()

        if (!isOrganizationBranchLoaded) return

        const nextPaymentDate = moment(organizationBranch.activeTariffDetails.nextPaymentDate)
        const menusActiveTillDate = moment(organizationBranch.activeTariffDetails.menusActiveTillDate)

        if (flags.isActive) {
            return `Действует до ${nextPaymentDate.format('DD.MM.YYYY HH:MM')}`
        } else if (!flags.isExpired) {
            return `Просрочен, меню активны до ${menusActiveTillDate.format('DD.MM.YYYY HH:MM')}`
        } else {
            return `Тариф истёк ${nextPaymentDate.format('DD.MM.YYYY HH:MM')}`
        }
    }

    const openPayForm = (tariff: TariffVariant) => {
        setChosenTariff(tariff)
        setOpenForm(true)
    }

    useEffect(() => {
        documentsStore.getOrganisationBranch();
        documentsStore.getServiceLegalDetails();
        generalStore.setPageTitle("Тариф");
        window.scrollTo(0, 0)
    }, [generalStore, documentsStore]);

    useEffect(() => {
        console.log(isOrganizationBranchLoaded)
        if (isOrganizationBranchLoaded) {
            setCompanyCard(organizationBranch?.companyEntityData?.companyCard)
        }
    }, [isOrganizationBranchLoaded])

    return !isOrganizationBranchLoaded ? <></> : <>
        <Helmet title="Тариф">
        </Helmet>
        <TariffPaymentForm open={openForm} tariff={chosenTariff} onClose={() => setOpenForm(false)}/>
        <Typography mb={2} component="h1" variant="h2" align="left">
            Текущий тариф
        </Typography>
        <Paper p={5}>
            <Box css={{
                display: 'flex',
                flexDirection: 'row',
                gridGap: 10,
                alignItems: 'center',
                padding: 20,
                border: '1px solid',
                borderRadius: 10
            }}>
                <Typography variant="h4">
                    {TariffTypes[organizationBranch?.activeTariffDetails?.type] || ""}
                </Typography>
                <Typography
                    variant={'subtitle2'}
                    style={{
                        borderRadius: 5,
                        padding: '2px 10px',
                        ...getBadgeColors(),
                    }}
                >
                    {getBadgeText()}
                </Typography>
            </Box>
        </Paper>

        <Typography mt={5} mb={2} component="h1" variant="h4" align="left">
            Данные для выставления счета
        </Typography>
        <Paper p={5}>
            <Box css={{
                display: 'flex',
                flexDirection: 'column',
                // border: '1px solid rgba(56, 54, 64, 0.4)',
                // borderRadius: 10,
                // padding: '15px 20px',
                // boxShadow: expanded ? '0px 0px 10px rgba(56, 54, 64, 0.4)' : null,
                //@ts-ignore
                transition: 'all 0.35s',
                //@ts-ignore
                // '&:hover': {
                //     boxShadow: '0px 0px 10px rgba(56, 54, 64, 0.4)',
                // }
            }}>

                <Box css={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                     onClick={() => setExpanded(!expanded)}>
                    {expanded ? <ExpandLess/> : <ExpandMore/>}
                    <Typography variant={'h6'}>
                        {expanded ? 'Свернуть' : 'Показать'}
                    </Typography>
                </Box>
                <Collapse in={expanded}>
                    <EditLegalData/>
                </Collapse>
            </Box>
        </Paper>

        <Typography mt={5} mb={2} component="h1" variant="h2" align="left">
            Тарифы
        </Typography>
        <Paper p={5}>
            <Box css={{
                display: 'flex',
                flexDirection: 'column',
                gridGap: 30,
            }}>
                <TariffCard key={"tariffSimple"} tariff={'Simple'} openForm={openPayForm}/>
                <TariffCard key={"tariffBasic"} tariff={'Basic'} openForm={openPayForm}/>
                <TariffCard key={"tariffAdvanced"} tariff={'Advanced'} openForm={openPayForm}/>
            </Box>
        </Paper>
    </>
}

export default observer(TariffPage)